// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"1d59e590","716":"3bbc6b11"}[chunkId] + ".chunk.js";
};